'use strict'

let watermark = {}

//domId 文字 字体大小 颜色
let setWatermark = (str, fontSize, textColor,domId,width,height) => {
    // let domCopy=document.getElementById('pdfDom').cloneNode(true) //结构、事件与数据都克隆

    let widthcopy=width||0
    let heightcopy=height||0
    var waterAppendDom = document.getElementById("pdfDom")
    let id = domId||'1.23452384164.123412415'
    if (!str) {
        return id
    }

    if (document.getElementById(id) !== null) {
        // document.body.removeChild(document.getElementById(id))
        waterAppendDom.removeChild(document.getElementById(id))
    }

    let canvas = document.createElement('canvas')
    let buHeight = 0
    if (fontSize <= 32) {
        buHeight = 99;
    } else if (fontSize > 32 && fontSize <= 60) {
        buHeight = 2;
    } else if (fontSize > 60 && fontSize <= 80) {
        buHeight = 4;
    } else if (fontSize > 80 && fontSize <= 100) {
        buHeight = 6;
    } else if (fontSize > 100) {
        buHeight = 10;
    }
    canvas.id = 'waterCanvas'// id为myCanvas
    canvas.height = fontSize + buHeight;
    canvas.padding = 30;
    let context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width * 2, canvas.height);
    context.textAlign = "center";
    canvas.width = 300;
    canvas.height = 200;
    context.fillStyle = textColor || 'rgba(200, 200, 200, 0.20)';
    context.font = fontSize + 'px Arial';
    context.textBaseline = 'middle';
    context.fillText(str, canvas.width / 3, canvas.height / 2);
    let div = document.createElement('div')
    div.id = id
    div.style.pointerEvents = 'none';
    div.style.top = '-50%';
    div.style.left = '-10%';
    div.style.position = 'fixed';
    div.style.zIndex = '9999';
    div.style.opacity = '0.2';
    div.style.transform = "rotate(-30deg)";
    div.style.width =widthcopy*4+3000+'px'
    div.style.height =heightcopy*2+3000+'px'
    div.style.background = 'url(' + canvas.toDataURL('image/png') + ') left top repeat';
    // document.body.appendChild(div)
    waterAppendDom?waterAppendDom.appendChild(div):document.body.appendChild(div)

    return id
}

// 该方法只允许调用一次
watermark.set = (str, fontSize, textColor,domId,width,height) => {
    let id = setWatermark(str, fontSize, textColor,domId,width,height)
    // clearInterval();
    // setInterval(() => {
    //     if (document.getElementById(id) === null) {
    //         id = setWatermark(str,fontSize,textColor)
    //     }
    // }, 500)
    window.onresize = () => {
        id= setWatermark(str, fontSize, textColor,domId,width,height)
    }
    return id
}
watermark.remove = (fontSize, textColor,domId) => {
    let id = setWatermark(false, fontSize, textColor,domId)
    if (document.getElementById(id) !== null) {
        var myWaterdiv = document.getElementById(id);
        document.getElementById("pdfDom").removeChild(myWaterdiv);
    }
    return true
}

export default watermark